import React from "react";
import { FlexDiv } from "@/components/Atoms/Box";
import StyledSvgSprite from "@/components/Atoms/SVGSprite";
import theme from "@/foundation/Theme";
import Typography from "@/foundation/Typography/V2";
import { isMobile } from "@/utils";
import { LogoContainer2, MoreItemCard, MoreItemLogoRow } from "./Style";

function MoreOfferBanner(Props) {
  const { isCardVariant, moreOffersLogoUrl } = Props;

  return (
    <MoreItemCard
      isCardVariant={isCardVariant}
      isMobile={isMobile}
      mt={!isCardVariant ? "32px" : "0px"}
      mb={isMobile ? "16px" : "0px"}
    >
      <FlexDiv
        flexDirection={isCardVariant || isMobile ? "column" : "row"}
        p={isCardVariant ? "8px" : "0px"}
        alignItems="center"
        justifyContent="center"
        mb={isCardVariant ? "32px" : "0px"}
      >
        <FlexDiv
          height="80px"
          width="80px"
          alignItems="center"
          justifyContent="center"
          borderRadius="20px"
          bg={theme.colorsV2.primary.shade_200}
        >
          <StyledSvgSprite
            icon="icon-receipt-discount"
            height="40px"
            width="40px"
          />
        </FlexDiv>
        <Typography
          variant="heading5"
          color={theme.colorsV2.primary.shade_800}
          mt={isCardVariant ? "8px" : "0px"}
          ml={!isCardVariant ? "8px" : "0px"}
          maxWidth={isMobile ? "357px" : "100%"}
          textAlign="center"
        >
          More exciting offers coming soon
        </Typography>
      </FlexDiv>
      {/* <MoreItemLogoRow isCardVariant={isCardVariant} isMobile={isMobile}>
        {moreOffersLogoUrl.map((logoUrl, index) => {
          return (
            <>
              <LogoContainer2
                isCardVariant={isCardVariant}
                width={["61px", "80px"]}
                height={["61px", "80px"]}
                alignItems="center"
                justifyContent="center"
                bg={theme.colors.white}
                showGradient={
                  index === 0 || index === moreOffersLogoUrl.length - 1
                }
              >
                <img
                  src={logoUrl}
                  alt=""
                  height="auto"
                  width="95%"
                  style={{
                    objectFit: "contain",
                  }}
                />
              </LogoContainer2>
            </>
          );
        })}
      </MoreItemLogoRow> */}
    </MoreItemCard>
  );
}

export default MoreOfferBanner;
